import React from 'react';
import { StatusBadge } from 'react-covideo-common';
import { CONNECTION_TYPES, ConnectionType } from './constants';
import { useTranslation } from 'react-i18next';

interface ConnectionChipProps {
  type: ConnectionType;
}

export const ConnectionChip = ({ type }: ConnectionChipProps) => {
  const { t } = useTranslation();
  switch (type) {
    case CONNECTION_TYPES.CONNECTED:
      return (
        <StatusBadge text={t(CONNECTION_TYPES.CONNECTED)} variant='success' />
      );
    case CONNECTION_TYPES['NOT CONNECTED']:
      return (
        <StatusBadge
          text={t(CONNECTION_TYPES['NOT CONNECTED'])}
          variant='error'
        />
      );
    case CONNECTION_TYPES.EXPIRED:
      return <StatusBadge text={t(CONNECTION_TYPES.EXPIRED)} variant='gray' />;
    default:
      return null;
  }
};
